import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { TextInput } from 'Ficha/components/TextInput'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import EmapoLink from 'Ficha/pdf/emapoLink'
import EvalTable from 'Ficha/components/evaluations/EvalTable'
import { atualizarEmapo } from 'firebase/firestoreData'

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "12px",
    textAlign: "justify",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field:{
    margin: '10px auto',
  },
  tableBox:{
    padding: 10,
  },
  formControl:{
    margin: 20,
  },
  miniTable:{
    maxWidth: 360,
    margin: '0 auto'
  },
  miniTableRow:{
    height: 42,
  },
  deleteButton:{
    margin: 20,
    border: '1px solid blue',
    color: 'blue'
  },
  heading:{
    marginLeft: 10,
  },
  buttons:{
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 30,
  },
  btn:{
    width: 80,
  },
  table:{
    width: '90%',
    margin: '30px auto'
  },
  texts: {
    margin: '0 auto',
    backgroundColor: 'rgb(240, 240, 240)',
    borderRadius: 8,
    maxWidth: '600px',
    padding: 8,
    paddingLeft: 15,
    textAlign: 'justify',
    boxShadow: '2px 2px 7px black'
  }
};

const useStyles = makeStyles(styles);

export default function Emapo(props) {
  const classes = useStyles();
  const ficha  = props.location.state
  const history = useHistory();
  const [showBtn, setShowBtn] = useState(false)
  const [riskSum, setRiskSum] = useState(0)
  const [riskText, setRiskText] = useState("")
  const [riskArray, setRiskArray] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])

  useEffect(() => {
  const timer = setTimeout(() => {
    setShowBtn(true)
  }, 1000);
  return () => clearTimeout(timer);
}, []);

  useEffect(() => {
    if (ficha.emapo){
      setRiskArray(ficha.emapo)
      updateRisk(ficha.emapo)
    }
  }, [ficha.emapo]);

  useEffect(()=>{
    let text = ""
    if (riskSum === 0) {
        text = <p>Não foi identificada <b>nenhuma </b>variável de Emapo para risco cardiovascular<br/>
          => Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos**
          é <b>MUITO BAIXO</b> com a incidência <b>menor que 1%</b>.<br/>
          * óbito ocorrido no período antecedente à alta hospitalar pós-operatória<br/>
          ** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto
            do miocárdio), eventos embólicos e arritmias cardíacas.</p>
        }
    if (riskSum > 0 && riskSum < 6) {
        text = <p>O paciente somou  <b>{riskSum} </b>pontos no escore Emapo<br/>
        => Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos**
        é <b>BAIXO</b> com a incidência <b>entre 1% e 3%</b>.<br/>
        * óbito ocorrido no período antecedente à alta hospitalar pós-operatória<br/>
        ** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto
          do miocárdio), eventos embólicos e arritmias cardíacas.</p>
        }
    if (riskSum > 5 && riskSum < 11) {
        text = <p>O paciente somou  <b>{riskSum} </b>pontos no escore Emapo<br/>
        => Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos**
        é <b>MODERADO</b> com a incidência <b>entre 3% e 7%</b>.<br/>
        * óbito ocorrido no período antecedente à alta hospitalar pós-operatória<br/>
        ** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto
          do miocárdio), eventos embólicos e arritmias cardíacas.</p>
          }
    if (riskSum > 10 && riskSum < 16) {
        text = <p>O paciente somou  <b>{riskSum} </b>pontos no escore Emapo<br/>
        => Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos**
        é <b>ELEVADO</b> com a incidência <b>entre 7% e 13%</b>.<br/>
        * óbito ocorrido no período antecedente à alta hospitalar pós-operatória<br/>
        ** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto
          do miocárdio), eventos embólicos e arritmias cardíacas.</p>
        }
    if (riskSum > 15 ) {
      text = <p>O paciente somou  <b>{riskSum} </b>pontos no escore Emapo<br/>
      => Nesse caso, a classificação do risco para óbito* e/ou eventos cardíacos**
      é <b>MUITO ELEVADO</b> com a incidência sendo <b>maior que 13%</b>.<br/>
      * óbito ocorrido no período antecedente à alta hospitalar pós-operatória<br/>
      ** eventos cardíacos incluem: eventos isquêmicos (angina instável e infarto
        do miocárdio), eventos embólicos e arritmias cardíacas.</p>
      }
    setRiskText(text)
  },[riskSum])

  let genText = <p><u>Sobre o Escore Emapo:</u><br/>
  - O EMAPO é um método que foi desenvolvido em 2007, no Brasil, pela Sociedade
  de Cardiologia do Estado de São Paulo. Ele propõe uma nova classificação bem
  completa, que contempla 27 diferentes variáveis. Cada uma destas variáveis possui
  uma pontuação específica, que devem ser somadas de modo que o valor encontrado
  estratificará o risco perioperatório do paciente em 5 níveis (muito baixo, baixo,
  moderado, elevado e muito elevado), de acordo com as taxas de complicações esperadas
  (menor que 1%, 1-3%, 3-7%, 7-13% e maior que 13%, respectivamente)</p>

  function updateRisk(riskArray) {
    setRiskArray(riskArray)
  }

  function calcRisk(riskArray) {
    let sum = 0
    for (let i = 0; i < riskArray.length; i++){
      sum = sum + riskArray[i]
    }
    setRiskSum(sum)
  }

  function saveRiskToDB() {
    atualizarEmapo(ficha.id, riskArray)
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                Índice de Risco Cardíaco Revisado de Emapo (IRCR)
              </h4>
              <p className={classes.cardCategoryWhite}>
                Todas as informações têm caráter apenas informativo.
                As condutas médicas devem ser decididas pelo médico assistente
                junto com o paciente, respeitando os quatro princípios bioéticos
                fundamentais: autonomia, beneficência, não-maleficência e justiça.
              </p>
              <p className={classes.cardCategoryWhite}>
              Fontes:
              - Pinho C et al. Multicenter study of perioperative evaluation for noncardiac surgeries in Brazil. 2007
              - Loureiro B. Perioperative risk scores for non-cardiac surgery: descriptions and comparisons. 2014
              - Gualandro DM et al. 3a Diretriz de Avaliação Cardiovascular Perioperatória da Sociedade Brasileira de Cardiologia. 2017
              </p>
            </CardHeader>
            <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Nome Completo"
                    name="nomeCompleto"
                    disabled
                    value={ficha.nome}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Procedimento(s)"
                    name="procedimento"
                    multiline
                    disabled
                    value={ficha.procedimentos}
                  />
                </GridItem>
                <div className={classes.table}>
                  <EvalTable onCalcRisk={calcRisk}
                             onUpdateRisk={updateRisk}
                             rows={[['Paciente acamado', 4],
                                   ['HAS + hipertrofia ventricular + alteração de ST', 4],
                                   ['AVC isquêmico < 3 meses', 4],
                                   ['DM com nefropatia/cardiopatia ou uso de insulina', 4],
                                   ['DAC com teste ergométrico negativo (menos de 3 meses)', 4],
                                   ['Cirurgia Intraperitoneal, da aorta e de seus ramos, intratorácica ou ortopédico', 4],
                                   ['Presença de aneurima aórtico assintomático, cirurgia não sugerida', 4],
                                   ['> 70 anos', 5],
                                   ['IAM (mais de 6 meses)', 5],
                                   ['Edema agudo pulmonar secundária a ICC (mais do que uma semana)', 5],
                                   ['FA crônica, taquiarritmias atriais paroxísticas e taquicardias ventriculares não sustentadas documentadas', 5],
                                   ['K < 3mEq/L, HCO3 < 20mEq/L; pO2<60, pCO2>50, uréia>50mg/dL, creatinina>2,3mg/dL, AST elevada ou doença hepática ativa', 5],
                                   ['IAM (menos de 6 meses) e não na fase aguda', 10],
                                   ['Angina Pectoris atualmente estável', 10],
                                   ['Angina instável episódio de dor no peito(menos de 3 meses) atualmente ausentes', 10],
                                   ['Edema agudo pulmonar secundária à ICC (menos de uma semana)', 10],
                                   ['Taquiarritmias supraventriculares sustentadas com resposta ventricular elevada; História documentada de arritmia ventricular sustentada repetitiva; História de fibrilação ventricular; Episódio de morte súbita abortada (mais de 3 meses); Portador de desfibrilador implantável automático  ', 10],
                                   ['Classificação da Canadian Cardiovascular Society Angina - classe III', 10],
                                   ['Cirurgia de emergência', 10],
                                   ['Cirurgia de transplante. Receptor de órgãos vitais: fígado e rins', 10],
                                   ['Estenose Mitral Severa', 10],
                                   ['Classificação da Canadian Cardiovascular Society Angina - classe IV', 20],
                                   ['Estenose aórtica crítica', 20],
                                   ['ICC classe IV', 20],
                                   ['IAM (fase aguda)', 20],
                                   ['Episódio recente de fibrilação ventricular ou morte súbita abortada com desfibrilador automático implantável', 20],
                                   ['Cirurgia de transplante. Destinatário órgão vital: pulmão', 20]]}
                              initialValues={riskArray}/>
                </div>
              </GridContainer>
              </form>
              <div className={classes.texts}>
              {riskText}
              {genText}
              </div>
              <div className={classes.buttons}>
              { showBtn && <div>
                <EmapoLink ficha={ficha}
                           risk={{risk: riskSum}}
                           link={<Button className={classes.btn} onClick={saveRiskToDB} color="primary">IMPRIMIR</Button>}
                />
              </div>
              }
              <Button className={classes.btn} onClick={()=>{saveRiskToDB(); history.goBack()}} color="primary">VOLTAR</Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
